import { render, staticRenderFns } from "./CredenciaisParceiros.vue?vue&type=template&id=98fae636&scoped=true&"
import script from "./CredenciaisParceiros.vue?vue&type=script&lang=js&"
export * from "./CredenciaisParceiros.vue?vue&type=script&lang=js&"
import style0 from "./CredenciaisParceiros.vue?vue&type=style&index=0&id=98fae636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fae636",
  null
  
)

export default component.exports